import { render } from "./LectMng.vue?vue&type=template&id=4b9e02ed&scoped=true"
import script from "./LectMng.vue?vue&type=script&lang=js"
export * from "./LectMng.vue?vue&type=script&lang=js"

import "./LectMng.vue?vue&type=style&index=0&id=4b9e02ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9e02ed"]])

export default __exports__